import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerPut = {
    path: "/template/content-blocker",
    method: ERouteHttpVerb.PUT
};
export { routeLocationContentBlockerPut };
